<ng-container *ngIf="product$ | async as product">
  <ng-container
    *ngIf="salesRepStockData(product?.salesRepStockData) && (showWarehouseFeature$ | async) === false"
    [ngSwitch]="product['inStockFlag']"
  >
    <div class="stock-info" *ngSwitchCase="true">
      <span class="text instock-text">{{ 'product.stockInfo.inStockMessage' | cxTranslate }}</span>
      <span *ngIf="product?.leadTime > 0 && product?.stock?.stockLevelStatus === 'inStock'" class="leadtime-text"
        >{{ 'product.stockInfo.leadtimeInstock' | cxTranslate : { unit: product?.leadTime } }}
        {{ 'product.stockInfo.day' | cxTranslate }}
      </span>
      <span *ngIf="product?.leadTime > 0 && product?.stock?.stockLevelStatus === 'backorder'" class="leadtime-text"
        >{{ 'product.stockInfo.leadtimeInstock' | cxTranslate : { unit: product?.leadTime } }}
        {{ 'product.stockInfo.day' | cxTranslate }}
      </span>
    </div>
    <ng-container *ngSwitchCase="false">
      <ng-container *ngIf="product?.stock?.stockLevelStatus == 'backorder'; else outOfStock">
        <div class="stock-info">
          <span class="text backorder-text">{{ 'product.stockInfo.backorderMessage' | cxTranslate }}</span>
          <span *ngIf="product?.leadTime > 0 && product?.stock?.stockLevelStatus === 'inStock'" class="leadtime-text"
            >{{ 'product.stockInfo.leadtimeInstock' | cxTranslate : { unit: product?.leadTime } }}
            {{ 'product.stockInfo.day' | cxTranslate }}
          </span>
          <span *ngIf="product?.leadTime > 0 && product?.stock?.stockLevelStatus === 'backorder'" class="leadtime-text"
            >{{ 'product.stockInfo.leadtimeInstock' | cxTranslate : { unit: product?.leadTime } }}
            {{ 'product.stockInfo.day' | cxTranslate }}
          </span>
        </div>
      </ng-container>
      <ng-template #outOfStock>
        <div class="stock-info-error">
          <mat-icon class="error-icon">error</mat-icon>
          <span class="error-text">{{ 'product.stockInfo.outOfStockMessage' | cxTranslate }}</span>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="product?.salesRepStockData">
    <ng-container
      *ngFor="let warehouse of checkSalesRepStockData(product?.salesRepStockData, showWarehouseFeature$ | async)"
      [ngSwitch]="warehouse.stockLevelStatus"
    >
      <ng-container *ngSwitchCase="'outOfStock'">
        <ng-container *ngIf="isBoolean(showWarehouseFeature$ | async)">
          <ng-container *ngIf="showWarehouseFeature$ | async; else showNotAvailable">
            <div class="stock-info">
              <ng-container *ngIf="product?.manualAllocation && manualAllocationEnabled; else productOutOfStock">
                <span class="text outofstock-text">{{ warehouse.warehouseName }}</span>
              </ng-container>
              <ng-template #productOutOfStock>
                <span class="text outofstock-text">
                  {{ warehouse.warehouseName }}({{
                    checkStockLevel(warehouse.stockLevel, showWarehouseFeature$ | async)
                  }})
                </span>
              </ng-template>
              <div class="leadtime-text">
                <span>
                  {{ 'product.stockInfo.nextAvailableDate' | cxTranslate : { date: warehouse?.monthLeadTime } }}
                </span>
              </div>
            </div>
          </ng-container>

          <ng-template #showNotAvailable>
            <div class="stock-info-error">
              <mat-icon class="error-icon">error</mat-icon>
              <span class="error-text">{{ 'product.stockInfo.outOfStockMessage' | cxTranslate }}</span>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="'discontinued'">
        <div *ngIf="showDiv" class="stock-info-error" [hidden]="addOverlay(product, product.isDiscontinued)">
          <mat-icon class="error-icon">error</mat-icon>
          <span class="error-text">{{ 'product.stockInfo.outOfStockMessage' | cxTranslate }}</span>
          <app-product-size-chart></app-product-size-chart>
        </div>
      </ng-container>

      <div class="stock-info" *ngSwitchCase="'backorder'">
        <ng-container *ngIf="product?.manualAllocation && manualAllocationEnabled; else productBackorder">
          <span class="text backorder-text">{{ warehouse.warehouseName }}</span>
        </ng-container>
        <ng-template #productBackorder>
          <span
            class="text"
            [class.instock-text]="
              warehouse?.stockLevelStatus === 'inStock' ||
              (warehouse?.stockLevelStatus === 'backorder' && warehouse?.stockLevel > 0)
            "
            [class.backorder-text]="warehouse?.stockLevelStatus === 'backorder' && warehouse?.stockLevel === 0"
          >
            {{ warehouse.warehouseName }}({{ checkStockLevel(warehouse.stockLevel, showWarehouseFeature$ | async) }})
          </span>
        </ng-template>

        <div class="leadtime-text">
          <ng-container *ngIf="showWarehouseFeature$ | async; else showLeadTime">
            <span *ngIf="warehouse?.monthLeadTime">
              {{ 'product.stockInfo.nextAvailableDate' | cxTranslate : { date: warehouse?.monthLeadTime } }}
            </span>
          </ng-container>
          <ng-template #showLeadTime>
            <span *ngIf="warehouse?.leadTime > 0">
              {{ 'product.stockInfo.leadtimeBackorder' | cxTranslate : { unit: warehouse?.leadTime } }}
              {{ 'product.stockInfo.day' | cxTranslate }}
            </span>
          </ng-template>
        </div>
      </div>

      <div class="stock-info" *ngSwitchCase="'inStock'">
        <span class="text instock-text">
          {{ warehouse.warehouseName }}({{ checkStockLevel(warehouse.stockLevel, showWarehouseFeature$ | async) }})
        </span>

        <div class="leadtime-text">
          <ng-container *ngIf="showWarehouseFeature$ | async; else showLeadTime">
            <span *ngIf="warehouse?.monthLeadTime">
              {{ 'product.stockInfo.nextAvailableDate' | cxTranslate : { date: warehouse?.monthLeadTime } }}
            </span>
          </ng-container>
          <ng-template #showLeadTime>
            <span *ngIf="warehouse?.leadTime > 0">
              {{ 'product.stockInfo.leadtimeBackorder' | cxTranslate : { unit: warehouse?.leadTime } }}
              {{ 'product.stockInfo.day' | cxTranslate }}
            </span>
          </ng-template>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <!-- Manual Allocation Info Card -->
  <ng-container
    *ngIf="product?.manualAllocation && manualAllocationEnabled && product?.stock?.stockLevelStatus !== 'discontinued'"
  >
    <div class="stock-info-manual-allocation">
      <mat-icon class="info-icon">phone</mat-icon>
      <span class="info-text">{{ 'product.manualAllocated' | cxTranslate }}</span>
    </div>
  </ng-container>

  <!-- Notify Me Toggle -->
  <ng-container *ngIf="product.notifyMe">
    <app-notify-me [productCode]="product.code"></app-notify-me>
  </ng-container>
</ng-container>
